<template>
    <div class="net-income-card">
        <el-card class="box-card" style="margin-bottom: 30px;" v-if="current_customer">
            <div slot="header" class="row d-flex align-items-center">
                <b-col cols="6">
                    <h3 class="mb-0">Net Income</h3>
                </b-col>
                <b-col v-if="!current_customer.cjp_id">
                    <el-button @click="$refs.drawer_net_income.viewDetails()" class="float-right py-0 text-primary" type="text">Edit</el-button>
                </b-col>
                <b-col v-else>
                    <el-button @click="$refs.customerJointNetIncomeModal.toggleView()" class="float-right py-0 text-primary" type="text">View Details</el-button>
                </b-col>
            </div>
            <div>
                <div v-if="!current_customer.cjp_id">
                    <div class="mb-2">
                        <span class="text-primary total-net-income">RM {{ parseFloat(current_customer.incomes.main.net_income).toLocaleString(undefined, {minimumFractionDigits: 2}) }}</span>
                        <b-badge pill variant="dark" class="text-white text-capitalize mx-3" v-if="current_customer.incomes.main.type">{{ current_customer.incomes.main.type }}</b-badge>
                    </div>
                    <div v-if="current_customer.incomes.variable.length > 0" class="d-flex align-items-center">
                        <b-icon icon="check-lg" variant="success" class="mr-2"></b-icon>
                        <span>Variable Income</span>
                    </div>
                </div>
                <div v-else>
                    <h4 class="mb-0">Total Joint Net Income</h4>
                    <h3 class="text-primary">RM{{ current_customer.incomes.main.net_income | moneyFormatter }}</h3>
                    <hr class="my-3">
                    <h4 class="badge bg-fintos">Individual</h4>
                    <div v-for="(joint_profile, index) in current_customer.customer_joint_profiles" :key="index" class="mb-2">
                        <h4 class="mb-0">{{ joint_profile.name }}</h4>
                        <h3 class="text-primary">RM{{ joint_profile.main_income.net_income | moneyFormatter }}</h3>
                    </div>
                </div>
            </div>
        </el-card>

        <!-- Drawer for Net Income Details -->
        <drawer-view-net-income-details ref="drawer_net_income"></drawer-view-net-income-details>
        <CustomerJointNetIncomeModal ref="customerJointNetIncomeModal" :customer="current_customer"/>
    </div>
</template>
<script>
    import { Card, Button } from 'element-ui'
    import DrawerViewNetIncomeDetails from '@/views/CustomerProfile/CustomerProfileDetails/OffCanvasDetails/DrawerNetIncome/DrawerNetIncome'
    import { mapState } from 'pinia'
    import { useCustomerStore } from '@/stores/customerStore'
    import CustomerJointNetIncomeModal from '@/views/CustomerProfile/CustomerProfileDetails/LeftProfileDetails/Modal/CustomerJointNetIncomeModal'

    export default {
        name: 'net-income',
        components: {
            CustomerJointNetIncomeModal,
            DrawerViewNetIncomeDetails,
            [Card.name]: Card,
            [Button.name]: Button,
        },
        data(){
            return{

            }
        },
        computed: {
            ...mapState(useCustomerStore,['current_customer'])
        },
    }
</script>